.virksomhetsListe {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: var(--dds-spacing-large-48);
}
